// extracted by css-extract-rspack-plugin
export default {"highlightedLineMenuButton":"HighlightedLineMenu-module__highlightedLineMenuButton__hVBhI","overlayPortalRoot":"HighlightedLineMenu-module__overlayPortalRoot__QDpCt"};